import React from 'react'
import styled from 'styled-components'
import { useUnmount } from 'react-nb-hooks'

import LKModal from '../../shared/LKModal'
import { useDetailsMeta } from '../detailsContext'

const StyledLKFooter = styled(LKModal)`
  .lk-window .lk-window-header {
    background: var(--color-window-background-header);
  }
`

const ModalMarkup = ({
  children,
  name,
  heading,
  icon,
  Footer,
  ID,
  hash,
  tabs,
  data,
  openContext,
  isModal,
  Header,
  onClose,
  size,
}) => {
  // TODO: investigate if this is in use
  useUnmount(() => {
    onClose()
  })

  const { onRefresh } = useDetailsMeta()

  return (
    <StyledLKFooter
      name={name}
      heading={heading}
      icon={icon}
      size={size}
      footer={
        Footer && (
          <Footer
            isModal={isModal}
            openContext={openContext}
            ID={ID}
            hash={hash}
            tabs={tabs}
            data={data}
            onRefresh={onRefresh}
          />
        )
      }
    >
      {Header && <Header ID={ID} hash={hash} tabs={tabs} data={data} />}
      {children}
    </StyledLKFooter>
  )
}

ModalMarkup.defaultProps = {
  size: 'ml',
}

export default ModalMarkup
